import { render } from "./FuneralViewFormType2.vue?vue&type=template&id=1874734f&lang=true"
import script from "./FuneralViewFormType2.vue?vue&type=script&lang=js"
export * from "./FuneralViewFormType2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__